import { render, staticRenderFns } from "./feeschange.vue?vue&type=template&id=585ee6e5&scoped=true"
import script from "./feeschange.vue?vue&type=script&lang=ts"
export * from "./feeschange.vue?vue&type=script&lang=ts"
import style0 from "./feeschange.vue?vue&type=style&index=0&id=585ee6e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ee6e5",
  null
  
)

export default component.exports